import './styles.css';
import Logo from '../../assets/img/logo_kisahruang.png';

const NotFound = () => {
  return (
    <main className="not-found__container">
      <img src={Logo} alt="logo" className="not-found__logo mb-3" />
      <h1 className="not-found__text--1">404</h1>
      <h3 className="">Page Not Found</h3>
    </main>
  );
};

export default NotFound;
